import React from 'react';
import './App.scss';
import CompareHash from './components/CompareHash';
import GenerateHash from './components/GenerateHash';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <div className="container">
        <div className="text-center">
          <h1 className="text-center">DCCC Swap Tools</h1>
          <h6 className="text-muted">
            Due to the intensive nature of Swap Operations, we recommend the{' '}
            <a
              href="https://www.google.com/chrome/browser/desktop/index.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Chrome
            </a>{' '}
            browser for these tools.
          </h6>
        </div>
        <CompareHash />
        <GenerateHash />
      </div>
      <Footer />
    </>
  );
}

export default App;
